import Tokens from '@uipath/apollo-core';
export default { fontFamily: Tokens.FontFamily.FontNormal };
